import React, { useEffect, useState } from 'react';

import styles from './styles.styl';
import cn from 'classnames/bind';
import { useParams } from 'react-router';
import { IconBackward } from '@consta/uikit/IconBackward';
import { Text } from '@consta/uikit/Text';
import { Badge } from '@consta/uikit/Badge';
import { Button } from '@consta/uikit/Button';
import { useHistory } from 'react-router-dom';
import { Tabs } from '@consta/uikit/Tabs';
import { AnalyticTabsEnum, SurveyTypeEnum } from 'src/utils/enum';
import AllAnalyticsResult from 'src/components/AllAnalyticsResult';
import AnalyticsResultTable from 'src/components/AnalyticsResultTable';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'src/redux/reducer';
import {
  analyticLoadedSelector,
  analyticPendingSelector,
  analyticSelector,
} from 'src/redux/features/analytic/selectors';
import {
  loadAnalytic,
  loadAnalyticIdle,
} from 'src/redux/features/analytic/actions';
import { Loader } from '@consta/uikit/Loader';

const cx = cn.bind(styles);

export interface IAnalyticsUrlParams {
  id: string;
}

interface Item {
  label: string;
  type: AnalyticTabsEnum;
}

const items: Item[] = [
  { label: 'Все результаты', type: AnalyticTabsEnum.ALL_RESULT },
  { label: 'Сводная таблица ответов', type: AnalyticTabsEnum.TABLE },
];

export interface IAnalyticsProps {}

const Analytics: React.FC<IAnalyticsProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [tab, setTab] = useState<Item>(items[0]);
  const { id } = useParams<IAnalyticsUrlParams>();

  const analyticLoaded = useSelector((state: State) =>
    analyticLoadedSelector(state),
  );

  const analyticPending = useSelector(analyticPendingSelector);

  const analyticData = useSelector(analyticSelector);

  useEffect(() => {
    if (!analyticLoaded) dispatch(loadAnalytic(id));
  }, []);

  useEffect(() => {
    if (analyticLoaded) dispatch(loadAnalyticIdle());
  }, [analyticLoaded, dispatch]);

  if (analyticPending) return <Loader className={cx('Analytics__loader')} />;
  return (
    <div className={cx('Analytics')}>
      <div className={cx('Analytics__header')}>
        <div className={cx('Analytics__header_title')}>
          <Button
            onlyIcon
            view="clear"
            iconLeft={IconBackward}
            onClick={() => history.goBack()}
          />
          <Text weight="semibold" size="xl">
            Аналитика
          </Text>
          <Badge
            view="stroked"
            label={
              analyticData?.type === SurveyTypeEnum.SURVEY
                ? 'Опрос'
                : 'Тестирование'
            }
            className={cx('Analytics__headerBadge')}
          />
        </div>
        <Text
          className={cx('Analytics__header_name')}
          weight="semibold"
          size="s"
        >
          {analyticData?.name}
        </Text>
      </div>
      <Tabs
        value={tab}
        onChange={({ value }) => setTab(value)}
        items={items}
        getLabel={(item) => item.label}
        size="s"
      />
      <div className={cx('Analytics__sort')}>
        {tab?.type === AnalyticTabsEnum.ALL_RESULT && <AllAnalyticsResult />}
        {tab?.type === AnalyticTabsEnum.TABLE && <AnalyticsResultTable />}
      </div>
    </div>
  );
};

export default Analytics;
